/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { Enabled } from './Enabled';
const EnabledWebhookParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'templateUrl',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'template_url',
    ],
]), Enabled);
export class EnabledWebhook extends Enabled {
    static decode(input) {
        return EnabledWebhookParser.decode(input).map(res => new EnabledWebhook(res));
    }
    static unsafeDecode(input) {
        return EnabledWebhook.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EnabledWebhookParser.encode(data);
    }
    static schema() {
        return EnabledWebhookParser.schema();
    }
}
